import { Program } from '@models/membership/Program'
import MuxUploader, {
  MuxUploaderDrop,
  MuxUploaderFileSelect,
  MuxUploaderProgress,
  MuxUploaderRetry,
  MuxUploaderStatus,
} from '@mux/mux-uploader-react'
import {
  fetchVideoDirectUploadUrl,
  postVideoPassthroughUrl,
} from '@services/membership/ProgramService'
import { Button, Space, Typography } from 'antd'
import { FC, useState } from 'react'

const { Text } = Typography

interface SBMuxUploaderProps {
  id: string
  item: Program
  setIsProcessing: (value: boolean) => void
}

const SBMuxUploader: FC<SBMuxUploaderProps> = ({
  id,
  item,
  setIsProcessing,
}) => {
  const [passthrough, setPassthrough] = useState<string>()

  return (
    <>
      <MuxUploader
        id={id}
        hidden
        style={{ display: 'none' }}
        endpoint={() =>
          fetchVideoDirectUploadUrl(item.slug).then(({ data }) => {
            setPassthrough(data.passthrough)
            return data.url!
          })
        }
        onSuccess={() => {
          setIsProcessing(true)
          postVideoPassthroughUrl(item.slug, passthrough!)
        }}
      />

      <MuxUploaderDrop
        muxUploader={id}
        overlay
        overlayText="Let it go"
        style={{ textAlign: 'center' }}
      >
        <Text slot="heading">Drop a video file here to upload</Text>
        <Text slot="separator" type="secondary">
          or
        </Text>

        <Space orientation="vertical" style={{ width: '100%' }}>
          <MuxUploaderStatus muxUploader={id} />
          <MuxUploaderRetry muxUploader={id} />
        </Space>

        <MuxUploaderFileSelect muxUploader={id}>
          <Button>Upload a video</Button>
        </MuxUploaderFileSelect>

        <Space orientation="vertical" style={{ width: '100%' }}>
          <MuxUploaderProgress
            muxUploader={id}
            type="percentage"
            style={{ color: item.primaryColor }}
          />
          <MuxUploaderProgress
            muxUploader={id}
            type="bar"
            style={{ ['--progress-bar-fill-color']: item.primaryColor }}
          />
        </Space>
      </MuxUploaderDrop>
    </>
  )
}

export { SBMuxUploader }
